import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { environment } from 'src/environments/environment';
import { AuthVerifyCodeActions } from '../../auth-verify-code.actions.enum';

@Component({
  selector: 'app-auth-verify-code-form',
  templateUrl: './auth-verify-code-form.component.html',
  styleUrls: ['./auth-verify-code-form.component.sass'],
})
export class AuthVerifyCodeFormComponent implements OnInit, OnChanges {
  @Input() formData: UntypedFormGroup;
  @Input() formInputs: string[];
  @Input() enabledButton: boolean;
  @Input() showLoginLoading: boolean;
  @Input() showLoginLoadingSms: boolean;
  @Input() showErrorCode: boolean;
  @Input() actionList: Actions<AuthVerifyCodeActions, any>;
  @Input() verifyCodeAction: AuthVerifyCodeActions;
  @Input() resendVerifyCodeAction: AuthVerifyCodeActions;
  @ViewChildren('formRow') rows: any;
  inputCodeError: boolean;

  constructor() {
    /** */
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showErrorCode && changes.showErrorCode.currentValue) {
      this.inputCodeError = true;
    }
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * method to the next input
   *
   * @param {*} event
   * @param {*} index
   * @memberof AuthVerifyCodeFormComponent.keyUpEvent
   */
  keyUpEvent(event: KeyboardEvent, index: number): void {
    const value = parseInt(event.key + '', 10);
    index = index + 1;
    if (event.key === 'Backspace') {
      // eslint-disable-next-line no-underscore-dangle
      this.rows._results[index - 2]?.nativeElement?.focus();
      return environment.guardClause;
    }
    if (Number.isNaN(value) || value < 0) {
      this.formData?.get(`input${index}`).setValue('', { emitEvent: false });
      return environment.guardClause;
    }
    // eslint-disable-next-line no-underscore-dangle
    if (this.rows._results[index]) {
      // eslint-disable-next-line no-underscore-dangle
      this.rows._results[index]?.nativeElement?.focus();
    }
  }
  /**
   * method to verify code
   *
   * @memberof AuthVerifyCodeFormComponent._eventVerifyCode
   */
  verifyCode(): void {
    this.actionList.emit(AuthVerifyCodeActions.VERIFY_CODE, null);
  }

  /**
   * method envet.emit to resend verify code
   *
   * @memberof AuthVerifyCodeFormComponent._eventResendVerifyCode
   */
  resendVerifyCode(): void {
    if (this.enabledButton) {
      this.actionList.emit(AuthVerifyCodeActions.RESEND_VERIFY_CODE, null);
    }
  }
}
